import React, { useEffect, useId } from "react";
import { ThemeWrapper } from "@verity/components";
import { CustomSettingData } from "../../settings-page";
import apiClient from "../../../../helpers/api-client";
import { CoreSwitch } from "@verity/components/core";
import { List, ListItem, Typography } from "@mui/material";
import i18n from "../../../../i18n";

export const BypassModeInput = (props: {
	loadData: { allowStrictMode: boolean; allowAiStrictMode: boolean };
	setting: CustomSettingData<boolean>;
	onSettingChange: (value?: boolean) => void;
	disabled?: boolean;
}) => {
	const [bypassModeEnabled, setBypassModeEnabled] = React.useState(
		props.setting.value ?? !props.loadData.allowStrictMode,
	);
	const titleId = useId();

	useEffect(() => {
		props.onSettingChange(bypassModeEnabled);
	}, [bypassModeEnabled, props]);

	const items = [
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.videoLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.videoDescription"),
		},
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.audioLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.audioDescription"),
		},
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.handoffLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.handoffDescription"),
		},
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.blockLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.blockDescription"),
		},
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.extensionBlockLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.extensionBlockDescription"),
		},
		{
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.screenLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.screenDescription"),
		},
	];

	if (props.loadData.allowAiStrictMode) {
		items.push({
			label: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.aiLabel"),
			description: i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.aiDescription"),
		});
	}

	return (
		<ThemeWrapper>
			<div style={{ maxWidth: "100%", overflowX: "auto" }}>
				<div style={{ minWidth: "420px" }}>
					<div style={{ display: "flex", paddingRight: "5px" }}>
						<div style={{ marginRight: "15px" }}>
							<Typography id={titleId} fontWeight={600} fontSize={15}>
								{i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.turnOnTitle")}
							</Typography>
							<Typography fontSize={14} lineHeight={1.6}>
								{i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.turnOnDescription")}
							</Typography>
						</div>
						<CoreSwitch
							checked={bypassModeEnabled}
							onChange={(e) => setBypassModeEnabled(e.target.checked)}
							disabled={props.disabled}
							labelTextType="left"
							inputProps={{ "aria-labelledby": titleId }}
						/>
					</div>
					<div style={{ margin: "13px 0 6px 0" }}>
						<Typography>{i18n.t("portal.webpages.settingsRootTSX.bypassModeTSX.settingDescription")}</Typography>
						<List sx={{ margin: "4px 0 0 16px", paddingLeft: "16px", listStyleType: "disc" }}>
							{items.map((item, idx) => (
								<ListItem key={idx} disableGutters disablePadding sx={{ display: "list-item" }}>
									<Typography component="span">
										<b>{item.label}</b>: {item.description}
									</Typography>
								</ListItem>
							))}
						</List>
					</div>
				</div>
			</div>
		</ThemeWrapper>
	);
};

export async function saveBypassMode(bypassModeEnabled?: boolean) {
	try {
		if (typeof bypassModeEnabled === "boolean") {
			await apiClient.institute.saveInstituteAllowStrictMode(!bypassModeEnabled);
		}
		return { ok: true };
	} catch (error) {
		console.error(error);
		return { ok: false, reason: "Failed to save bypass mode setting." };
	}
}
